import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Order } from 'src/app/models/order.model';
import { OrderServicePlan } from 'src/app/models/order_service_plan.model';
import { OrderService } from 'src/app/services/order.service';
import { OrderServicePlanService } from 'src/app/services/order_service_plan.service';
import { PaymentService } from 'src/app/services/payment.service';
import { ServiceProviderService } from 'src/app/services/service-provider.service';
import { ShoppingService } from 'src/app/services/shopping.service';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { UserService } from 'src/app/services/user_service.service';
import { RemoveItemAction, UpdateQuantityAction } from 'src/app/store/actions/shopping.actions';
import { AppState } from 'src/app/store/models/app-state.model';
import { ShoppingItem } from 'src/app/store/models/shopping-item.model';
import { MatDivider, MatDividerModule } from "@angular/material/divider";
import { MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, MatExpansionPanelHeader, MatExpansionModule } from "@angular/material/expansion";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatCheckbox, MatCheckboxModule } from "@angular/material/checkbox";
import { MatProgressBar, MatProgressBarModule } from "@angular/material/progress-bar";
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCard, MatCardModule } from "@angular/material/card";

@Component({
    selector: 'app-checkout',
    templateUrl: './checkout.component.html',
    styleUrls: ['./checkout.component.scss'],
    imports: [
    MatDividerModule,
    MatExpansionModule,
    MatIconModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    MatTableModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule
]
})
export class CheckoutComponent implements OnInit {
    currentOrder: Order = new Order();
    orderList: OrderServicePlan[] = [];
    displayedColumns: string[] = ['Description', 'Appointment Location', 'Appointment Length', 'Rate', 'Quantity Requested', 'Total Cost', 'Remove Item'];
    loading = true;
    shoppingValues: ShoppingItem[] = [];
    storeValues: Observable<ShoppingItem[]> | undefined;
    storeSub: any;
    termsLink!: string;
    termsFormGroup: FormGroup = new FormGroup({
        agreedToTermsForm: new FormControl(false),
    })


    constructor(
        private store: Store<AppState>,
        private tokenStorageService: TokenStorageService,
        private paymentService: PaymentService,
        private orderServicePlanService: OrderServicePlanService,
        private orderService: OrderService,
        private shoppingService: ShoppingService,
        private router: Router,
        private userService: UserService,
    ) { }

    ngOnInit() {
        localStorage.setItem('ReturnToCheckout', 'false');
        this.currentOrder.costOfServices = 0;
        this.currentOrder.processingFee = 0;
        this.currentOrder.total = 0;
        if (this.tokenStorageService.getUser() != null && this.tokenStorageService.getToken() != null) {
            this.getCartItems();
        } else {
            this.getGuestCart();
        }

        this.userService.get(['Terms'], new Map).subscribe((result) => {
            this.termsLink = result.link;
        });
    }

    checkCart(): void {
        this.shoppingService.updateCartStock(['cartCheck'], JSON.parse(JSON.stringify(this.orderList))).subscribe((servicePlanQuantityUnavailable) => {
            servicePlanQuantityUnavailable.forEach((element: any) => {
                const matchingIndex = this.orderList.findIndex(orderServicePlan => element.servicePlanId == orderServicePlan.servicePlanId && element.appointmentLocation?.toLowerCase() == orderServicePlan.appointmentLocation?.toLowerCase());

                if (matchingIndex > -1) {
                    this.orderList[matchingIndex].isOutOfStock = true;
                    this.orderList[matchingIndex].quantityAvailable = element.servicePlanQty;
                }
            });
        });
    }

    getCartItems(): void {
        const queryParams = new Map([
            ["userId", this.tokenStorageService.getUser().id],
            ["status", 'pending'],
        ]);
        this.orderService.get([], queryParams).subscribe((order) => {
            this.currentOrder = order[0];
            this.orderList = order[0].orderServicePlanModel;
            this.checkCart();
            this.loading = false;
        }, (() => { this.loading = false; }));
    }

    getGuestCart(): void {
        this.storeValues = this.store.select(store => store.shopping.items);
        this.storeSub = this.storeValues.subscribe(store => {
            this.shoppingValues = [...store];
            this.shoppingValues = JSON.parse(JSON.stringify(this.shoppingValues));

            this.shoppingService.updateGuestCart(['GuestCart'], this.shoppingValues).subscribe((result) => {
                this.orderList = result;
                this.checkCart();
            });

            this.shoppingService.updateGuestOrder(['GuestOrder'], this.shoppingValues).subscribe((result) => {
                this.currentOrder = result;
            });

            this.loading = false;
        }, () => { this.loading = false });
        this.storeSub.unsubscribe();
    }

    beginStripePayment(): void {
        this.shoppingService.updateCartStock(['cartCheck'], JSON.parse(JSON.stringify(this.orderList))).subscribe((result) => {
            if (result.length == 0) {
                const emptyMap = new Map();
                const userId = this.tokenStorageService.getUser().id;
                this.paymentService.get([userId], emptyMap).subscribe((stripeURL) => {
                    window.location.href = stripeURL.model.stripeSessionUrl;
                });
            }
        });
    }

    removeItem(orderServicePlan: OrderServicePlan): void {
        let newShoppingItem: ShoppingItem = {
            id: orderServicePlan.servicePlanId,
            quantity: orderServicePlan.quantity,
            appointmentLocation: orderServicePlan.appointmentLocation,
        }
        if (this.tokenStorageService.getUser() != null && this.tokenStorageService.getToken() != null) {
            this.orderServicePlanService.delete(orderServicePlan.orderServicePlanId).subscribe(() => {

                this.store.dispatch(new RemoveItemAction(newShoppingItem))
                this.getCartItems();
            });
        } else {
            this.orderList = this.orderList.filter(x => x.servicePlanId != orderServicePlan.servicePlanId);
            this.store.dispatch(new RemoveItemAction(newShoppingItem));
            this.getGuestCart();
        }
    }

    routeToLogin(): void {
        localStorage.setItem('ReturnToCheckout', 'true');
        this.router.navigate(['login']);
    }

    get isUserLoggedIn(): boolean {
        if (this.tokenStorageService.getUser() != null && this.tokenStorageService.getToken() != null) {
            return true;
        }
        return false;
    }

    get isCartEmpty(): boolean {
        if (this.orderList.length > 0) {
            return true;
        }
        return false;
    }

    get agreedToTerms(): boolean {
        if (this.termsFormGroup.controls.agreedToTermsForm.value) {
            return true;
        }
        return false;
    }

    onQuantityChange(newQuantity: number, orderServicePlan: OrderServicePlan): void {
        this.loading = true;
        if (newQuantity >= 0) {
            let newShoppingItem: ShoppingItem = {
                id: orderServicePlan.servicePlanId,
                quantity: newQuantity,
                appointmentLocation: orderServicePlan.appointmentLocation,
            }
            this.store.dispatch(new UpdateQuantityAction(newShoppingItem));
            this.getGuestCart();
        }

        if (this.isUserLoggedIn && newQuantity >= 0) {
            orderServicePlan.quantity = newQuantity;
            this.orderServicePlanService.put([orderServicePlan.orderServicePlanId], orderServicePlan).subscribe(() => {
                this.getCartItems();
                this.loading = false;
            });
        }
        this.loading = false;
    }
}
